import {useParams} from "react-router-dom";
import {ReactElement, useEffect, useState} from "react";
import {useLoadChartOfAccountsMappingQuery} from "../../../__generated__/generated_types";
import {Coa, ExternalCoa, ExternalCoaMapping} from "./types";
import {ExternalChartOfAccountsDnDMapping} from "./ExternalChartOfAccountsDnDMapping";
import {AdminWrapper} from "../../admin/AdminWrapper";

export interface ExternalChartOfAccountsMappingProps {
    externalCoaId: string;
    coaId: string;
}

export function ExternalChartOfAccountsMapping(props: ExternalChartOfAccountsMappingProps): ReactElement {
    const {data: mapping, loading: mappingLoading} = useLoadChartOfAccountsMappingQuery({
        fetchPolicy: "no-cache",
        variables: {
            externalCoaId: props.externalCoaId,
            coaId: props.coaId
        }
    });
    const [coa, setCoa] = useState<Coa | null>(null);
    const [externalCoa, setExternalCoa] = useState<ExternalCoa | null>(null);
    const [externalCoaMapping, setExternalCoaMapping] = useState<ExternalCoaMapping | null>(null);

    useEffect(() => {
        if(mapping && !mappingLoading) {
            if(mapping.getExternalChartOfAccounts) {
                setExternalCoa(mapping.getExternalChartOfAccounts);
                setExternalCoaMapping(mapping.getExternalChartOfAccounts.accountsMapping);
            }
            if(mapping.listChartOfAccountsById) {
                setCoa(mapping.listChartOfAccountsById);
            }
        }
    }, [mapping, mappingLoading]);

    if(mappingLoading) {
        return <div>Loading...</div>;
    }

    if(coa && externalCoa) {
        return <ExternalChartOfAccountsDnDMapping
                coa={coa}
                externalCoa={externalCoa}
                mapping={externalCoaMapping}
        />;
    }

    return <div>
        Unable to load data. Please try again later.
    </div>;
}

export function ExternalChartOfAccountsMappingPage(): ReactElement {
    // This a wrapper to allow ExternalChartOfAccountsMapping to be used
    // as page via router.
    const {externalCoaId, coaId} = useParams<{externalCoaId: string, coaId: string}>();
    return <AdminWrapper><ExternalChartOfAccountsMapping externalCoaId={externalCoaId} coaId={coaId} /></AdminWrapper>
}